<template>
  <div class="choose-address-coordinates">
    <div class="button-group d-flex justify-between">
      <v-row dense class="justify-space-between">
        <v-col sm="5">
          <v-btn
            class="button button-back"
            width="100%"
            color="#F1F3F6"
            @click="close"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
        <v-col sm="5">
          <v-btn
            :disabled="!coords || geocoding"
            :loading="geocoding"
            class="button button-apply"
            width="100%"
            color="#F1F3F6"
            @click="save"
          >
            <font-awesome-icon icon="check" />
            Подтвердить
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <h1 class="step-title font-weight-regular">
      Укажите точку на карте:
    </h1>
    <div class="choose-address-coordinates-dialog_inner">
      <div class="choose-address-coordinates-map">
        <yandex-map
          :settings="settings"
          :coords="mapCenter"
          :zoom="11"
          @click="onMapClick"
          @map-was-initialized="onMapReady"
        >
          <map-polygon
            v-for="p in polygons"
            :key="`polygon-${p.id}`"
            :polygon="p"
            :show-balloon="false"
            @click="onMapClick"
          />
          <ymap-marker
            v-if="coords"
            :coords="coords"
            :marker-id="1"
            marker-type="placemark"
            :icon="markerIcon"
          />
        </yandex-map>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex'
  import yandexMap, { loadYmap, ymapMarker } from 'vue-yandex-maps'
  import _ from 'lodash'
  import MapPolygon from '@/components/geo/couriers-map/MapPolygon.vue'

  export default {
    name: 'ChooseAddressCoordinates',
    components: {
      MapPolygon,
      yandexMap,
      ymapMarker,
    },
    emits: ['close', 'save'],
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      center: {
        type: Array,
        default: null,
      },
      // когда true — событие save эмитит (coords, address): адрес из обратного геокодера Яндекса
      withGeocode: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        coords: null,
        geocoding: false,
      }
    },
    computed: {
      ...mapState({
        apiKey: state => state.app.yandexMapsYandexMapsApiKey,
      }),
      ...mapGetters({
        polygons: 'polygons/getPolygons',
        globalFilial: 'branches/getGlobalFilial',
      }),
      filialCoords () {
        const f = this.globalFilial
        if (f && f.lat != null && f.lng != null) {
          return [f.lat, f.lng]
        }
        if (f && f.region && Array.isArray(f.region.mapCenter)) {
          return f.region.mapCenter
        }
        return null
      },
      mapCenter () {
        return this.coords || this.center || this.filialCoords || [55.762832, 37.611520]
      },
      settings () {
        return {
          apiKey: this.apiKey,
          lang: 'ru_RU',
          coordorder: 'latlong',
          version: '2.1',
        }
      },
      markerIcon () {
        return {
          color: 'darkOrange',
        }
      },
    },
    async mounted () {
      // await loadYmap({ ...this.settings, debug: true })
      // здесь доступна переменная ymaps
      // console.log('ymaps', ymaps)
      // console.log(this.settings)
    },
    created () {
      if (_.isEmpty(this.polygons)) {
        this.loadPolygons()
      }
    },
    methods: {
      onMapClick (event) {
        console.log('onMapClick', event.get('coords'))
        this.coords = event.get('coords')
      },
      onMapReady (map) {
        if (!window.ymaps) return
        const searchControl = map.controls.get('searchControl')
        if (!searchControl) return
        this._searchControl = searchControl

        // При показе результата поиска: запоминаем его координаты и добавляем
        // в нативный балун кнопку «Выбрать».
        searchControl.events.add('resultshow', (e) => {
          searchControl.getResult(e.get('index')).then((obj) => {
            this._searchCoords = obj.geometry.getCoordinates()
          })
          setTimeout(() => this.injectSelectButton(), 60)
        })
      },
      injectSelectButton () {
        if (!this.$el) return
        const content = this.$el.querySelector('[class*="balloon__content"]')
        if (!content || content.querySelector('.search-select-balloon__btn')) {
          return
        }
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = 'search-select-balloon__btn'
        btn.textContent = 'Выбрать'
        btn.addEventListener('click', () => {
          if (!this._searchCoords) return
          this.coords = this._searchCoords.slice()
          if (this._searchControl) this._searchControl.hideResult()
        })
        content.appendChild(btn)
      },
      close () {
        this.$emit('close')
        this.$emit('input', false)
      },
      async save () {
        if (!this.withGeocode) {
          this.$emit('save', this.coords)
          this.coords = null
          this.close()
          return
        }

        this.geocoding = true
        const address = await this.reverseGeocode(this.coords)
        this.geocoding = false

        this.$emit('save', this.coords, address)
        this.coords = null
        this.close()
      },
      async reverseGeocode (coords) {
        try {
          await loadYmap({ ...this.settings })
          const ymaps = window.ymaps
          if (!ymaps) {
            return null
          }
          const res = await ymaps.geocode(coords, { results: 1 })
          const geoObject = res.geoObjects.get(0)
          if (!geoObject) {
            return null
          }
          const localities = geoObject.getLocalities()
          return {
            city: localities && localities.length ? localities[0] : null,
            street: geoObject.getThoroughfare() || null,
            house: geoObject.getPremiseNumber() || null,
          }
        } catch (e) {
          console.error('reverseGeocode failed', e)
          return null
        }
      },
      async loadPolygons () {
        await this.$store.dispatch('polygons/getPolygonsFromApi')
      },
    },
  }
</script>

<style scoped lang="less">
.choose-address-coordinates {

  .step-title {
    font-size: 2.42em;
    line-height: 1;
    margin-bottom: 0.97em;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      height: 80px;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      border-radius: 10px;

      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-apply {
      background-color: @color-success !important;
      color: #ffffff;
      border-radius: 10px;

      &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        box-shadow: none !important;

        svg {
          .fill-svg(#00000042);
        }
      }

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  &-dialog_inner {
    padding: 0;
  }

  &-map {
    position: relative;
    height: calc(100vh - 300px);
    max-height: 70vh;
    //margin: 0 30px;
    .ymap-container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

<!-- Нескоупленный: DOM балуна ymaps живёт вне scope компонента -->
<style lang="less">

.choose-address-coordinates {
  .search-select-balloon__btn {
    //margin-top: 8px;
    border: 0;
    border-radius: 8px;
    background-color: @color-success;
    color: #fff;
    padding: 8px 14px;
    font-size: 14px;
    cursor: pointer;
  }

  .search-select-balloon__btn:hover {
    opacity: 0.92;
  }

  [class*='-islets_card__buttons'],
  [class*='-islets_card__row-links'] {
    display: none;
  }
}

</style>
